export default function fullwidthCTAHandler() {
  const placeInFlow = (fullwidthCTA) => {
    const windowWidth = $(window).width();
    if (windowWidth > 1606) {
      $(fullwidthCTA).insertAfter('li.tile:eq(12)');
    } else if (windowWidth > 1336) {
      $(fullwidthCTA).insertAfter('li.tile:eq(8)');
    } else if (windowWidth > 860) {
      $(fullwidthCTA).insertAfter('li.tile:eq(9)');
    } else if (windowWidth > 560) {
      $(fullwidthCTA).insertAfter('li.tile:eq(8)');
    }
  };

  const checkForFullwidthCTA = () => {
    const ctaTiles = [...document.querySelectorAll('.tile.single.cta:not(#flipbot-calendly-cta)')];

    if (ctaTiles) {
      const fullwidthTiles = ctaTiles.filter((tile) =>
        tile.dataset.ctaName.includes('fullwidth')
      );

      if (fullwidthTiles.length !== 0) {
          var fullwidthCTA = fullwidthTiles[0];
          $(fullwidthCTA).addClass('fullwidth-cta');
          placeInFlow(fullwidthCTA);
      }

    }
  };

  if ($('.fullwidth-cta').length === 0) {
    checkForFullwidthCTA();
  } else {
    placeInFlow();
  }
}



// WEBPACK FOOTER //
// ./scriptPartials/fullwidthCTAHandler.js